import Vue from 'vue';
import { getPassportUrl } from '@/utils/other';
export default Vue.extend({
    name: 'updatingDocumentPopupChunk',
    methods: {
        onBtnClick() {
            window.location.href = getPassportUrl('/id/legal-information', { withAcceptor: true });
        }
    }
});
